export default {
    NOT_FOUND: 404,
    SERVICE_UNAVAILABLE: 503,
};
